// 在庫不足フォームの CSS。
//
// 全て `.zkform` にスコープを切る（素のタグセレクタで店のテーマを壊さないための作法）。
// 前半（.zkg）は入口の3択カードで、ES さんが page/2524 に書いた CSS の原文に
// `.zkform ` の接頭辞を付けたもの（Issue #20）。後半はフォーム本体で page/2510 の原文を踏襲。
// 色や間隔を変える意図が無い限りそのまま。
//
// Issue #24 で原文から変えた点（フォームを常時カードの下に出すため、カードを低くした）:
//   ・絵の高さ 150 → 96px、カードの余白を詰めた。説明文の行数は変えていない
//   ・「分納での発送は承っておりません」（.zkg-pill）は②カードの中に移り、小さくした
//   ・②③に押せる合図（.zkg-cta）、ホバーで枠が濃くなる、選択中（.is-picked）は枠色と背景で強調

export const CSS = `
.zkform{max-width:960px;margin:0 auto;font-family:"Hiragino Kaku Gothic ProN","Meiryo",sans-serif;line-height:1.7;color:#333;}

/* ---- 入口の3択カード（page/2524 原文。.zkform を前置しただけ） ---- */
.zkform .zkg{max-width:960px;margin:0 auto;padding:6px 0 10px;color:#3a2a18;line-height:1.6;-webkit-text-size-adjust:100%;}
.zkform .zkg *{box-sizing:border-box;}
.zkform .zkg-head{display:flex;align-items:center;justify-content:center;gap:14px;}
.zkform .zkg-head .deco{flex:0 0 auto;width:34px;height:34px;}
.zkform .zkg-h{margin:0;font-size:32px;font-size:clamp(21px,3.2vw,32px);font-weight:bold;line-height:1.3;text-align:center;letter-spacing:.04em;}
.zkform .zkg-uline{display:block;width:100%;max-width:820px;margin:6px auto 0;}
/* ピルはカード幅（container）に合わせて縮み、それでも収まらなければ折り返す（nowrap だと左サイドバーのある店で
   カード幅 ≒200px のときはみ出る。2026-09-22 パックジャパンで田口さん報告）。max-width で必ずカード内に収める */
.zkform .zkg-pill{display:table;max-width:100%;box-sizing:border-box;margin:10px auto 0;background:#fdeaf0;color:#e0334f;font-size:14px;font-size:clamp(10.5px,5cqw,14px);font-weight:bold;line-height:1.4;padding:4px 10px;border-radius:999px;text-align:center;white-space:normal;}
.zkform .zkg-cards{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;}
.zkform .zkg-cards.zkg-two{grid-template-columns:repeat(2,1fr);max-width:640px;margin:0 auto;}
.zkform .zkg-card{display:flex;flex-direction:column;background:#fff;border:2px solid #ddd;border-radius:16px;padding:12px 12px 14px;container-type:inline-size;}
.zkform .zkg-hd{display:flex;align-items:center;justify-content:center;min-height:58px;border-radius:10px;padding:9px 6px;text-align:center;font-weight:bold;font-size:18px;font-size:clamp(14px,6.4cqw,18px);line-height:1.35;}
.zkform .zkg-sep{margin:12px 4px 4px;border:0;border-top:2px dotted #ccc;}
.zkform .zkg-fig{display:flex;flex:0 0 auto;align-items:center;justify-content:center;min-height:96px;margin:6px 0 8px;}
.zkform .zkg-fig>svg{max-height:96px;max-width:100%;height:auto;width:auto;}
.zkform .zkg-desc{margin:0;font-size:16px;font-size:clamp(11.5px,5.5cqw,16px);line-height:1.7;text-align:center;color:#333;}
/* 押せる合図（Issue #24）。flex column の末尾に置き、margin-top:auto で3枚の下端を揃える */
.zkform .zkg-cta{margin:12px 0 0;padding-top:8px;border-top:1px solid #eee;font-size:14px;font-size:clamp(12px,4.8cqw,14px);font-weight:bold;text-align:center;line-height:1.4;margin-top:auto;padding-top:10px;}
.zkform .zkg-stock{margin:12px 0 0;padding-top:8px;border-top:1px solid #eee;font-size:15px;font-size:clamp(12px,5cqw,15px);font-weight:bold;text-align:center;color:#4e9c3a;}
.zkform .zkg-c1 .zkg-cta{color:#4e9c3a;border-top:0;padding-top:4px;}
.zkform .zkg-back{color:inherit;text-decoration:none;}
.zkform .zkg-back:hover{text-decoration:underline;}
.zkform .zkg-c2 .zkg-cta{color:#2f7ad0;}
.zkform .zkg-c3 .zkg-cta{color:#e0405f;}
.zkform .zkg-c2 .zkg-desc + .zkg-pill + .zkg-cta{margin-top:auto;}
.zkform .zkg-c1{border-color:#c3e0b0;}
.zkform .zkg-c1 .zkg-hd{background:#eef7e6;color:#4e9c3a;}
.zkform .zkg-c1 .zkg-sep{border-color:#bcdfa8;}
.zkform .zkg-c2{border-color:#aecfef;}
.zkform .zkg-c2 .zkg-hd{background:#e9f2fc;color:#2f7ad0;}
.zkform .zkg-c2 .zkg-sep{border-color:#a9cbee;}
.zkform .zkg-c3{border-color:#f6bccc;}
.zkform .zkg-c3 .zkg-hd{background:#fdecf1;color:#e0405f;}
.zkform .zkg-c3 .zkg-sep{border-color:#f5b8c9;}
.zkform .zkg-pick{cursor:pointer;transition:box-shadow .15s ease,background-color .15s ease,border-color .15s ease;}
.zkform .zkg-pick:hover{box-shadow:0 3px 12px rgba(0,0,0,.14);}
.zkform .zkg-c2.zkg-pick:hover{border-color:#2f7ad0;}
.zkform .zkg-c3.zkg-pick:hover{border-color:#e0405f;}
.zkform .zkg-pick:focus{outline:3px solid #ffc107;outline-offset:2px;}
.zkform .zkg-pick:focus:not(:focus-visible){outline:none;}
/* 選択中。枠色を濃く・背景を付けて「いま選んでいる」と分かるようにする */
.zkform .zkg-c2.is-picked{background:#f2f8ff;border-color:#2f7ad0;box-shadow:0 0 0 2px rgba(47,122,208,.25);}
.zkform .zkg-c3.is-picked{background:#fff5f8;border-color:#e0405f;box-shadow:0 0 0 2px rgba(224,64,95,.25);}
.zkform .zkg-warn{display:flex;align-items:center;gap:12px;margin:18px auto 0;padding:12px 18px;border:1px solid #ddd;border-radius:12px;background:#fff;}
.zkform .zkg-warn svg{flex:0 0 auto;width:30px;height:auto;}
.zkform .zkg-warn p{margin:0;font-size:16px;font-size:clamp(13px,1.5vw,16px);line-height:1.6;color:#444;}
@media screen and (max-width:950px){
.zkform .zkg-head{gap:8px;}
.zkform .zkg-head .deco{width:24px;height:24px;}
.zkform .zkg-cards{grid-template-columns:1fr;gap:12px;}
.zkform .zkg-card{flex-direction:row;flex-wrap:wrap;align-items:center;padding:10px 12px 14px;}
.zkform .zkg-hd{width:100%;min-height:0;font-size:18px;}
.zkform .zkg-sep{width:100%;margin:10px 4px 2px;}
.zkform .zkg-fig{flex:0 0 30%;min-height:0;margin:6px 0;}
.zkform .zkg-fig>svg{max-height:88px;}
.zkform .zkg-desc{flex:1 1 0;min-width:0;font-size:14px;font-size:clamp(12px,3.7vw,14px);line-height:1.75;text-align:left;padding-left:12px;}
.zkform .zkg-pill{width:100%;display:block;margin:8px 0 0;white-space:normal;}
.zkform .zkg-cta{width:100%;margin-top:8px;}
.zkform .zkg-stock{width:100%;margin-top:8px;}
.zkform .zkg-warn{align-items:flex-start;}
}

/* ---- フォーム本体（page/2510 原文）。カードの下に 680px 幅で置く ---- */
.zkform .zk-panel{max-width:680px;margin:20px auto 0;}
.zkform .zk-panel[hidden]{display:none;}
.zkform h3{font-size:16px;background:#fff4f4;border-left:6px solid #e60012;padding:6px 12px;margin:22px 0 12px;}
/* .fld は label 要素のこともある（入力欄を包んで for を使わない。Issue #19）。見出し .q は span。 */
.zkform .fld{display:block;margin:0 0 14px;font-weight:normal;}
.zkform .q{display:block;font-weight:bold;margin:0 0 4px;}
.zkform .req{color:#e60012;font-size:12px;margin-left:4px;}
.zkform input[type=text],.zkform input[type=email],.zkform input[type=tel],.zkform textarea{
  width:100%;box-sizing:border-box;padding:8px;border:1px solid #bbb;border-radius:4px;font-size:15px;}
.zkform textarea{height:80px;}
.zkform .radio{display:block;margin:3px 0;font-weight:normal;}
/* パックジャパンのテーマは input[type=radio] に transform:scale(1.5) を掛け、中心拡大で丸の左が列外にはみ出て切れる（Issue #64、2026-09-22 田口さん報告）。
   旧 /page/694 直書きの CSS と同じ打ち消し。他店では transform が無いので効かない */
.zkform .radio input[type=radio]{transform:none !important;width:16px;height:16px;margin:0 8px 0 2px;vertical-align:-3px;}
.zkform .radio small{color:#666;font-weight:normal;}
.zkform .prod{background:#f7f7f7;border:1px solid #ddd;border-radius:4px;padding:8px 10px;font-size:14px;}
.zkform .hp{position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;}
.zkform .btn{display:inline-block;background:#e60012;color:#fff;border:none;border-radius:6px;padding:12px 28px;font-size:17px;font-weight:bold;cursor:pointer;}
.zkform .btn:disabled{background:#aaa;cursor:default;}
.zkform .msg{margin:14px 0;padding:12px 16px;border-radius:6px;font-size:15px;display:none;}
.zkform .msg.ok{display:block;background:#eef8ee;border:1px solid #a5d6a7;color:#2e7d32;}
.zkform .msg.err{display:block;background:#fff0f0;border:1px solid #ef9a9a;color:#c62828;}
.zkform .note{font-size:12px;color:#777;margin-top:10px;}
.zkform .zk-mail{color:#e60012;font-weight:bold;display:block;margin-top:6px;}
/* 送信完了の枠（.msg.ok の中） */
.zkform .zk-done{padding:18px 20px;}
.zkform .zk-done-head{display:flex;align-items:center;gap:10px;font-size:22px;line-height:1.3;margin:0 0 8px;}
.zkform .zk-done-check{flex:0 0 auto;width:32px;height:32px;border-radius:50%;background:#2e7d32;color:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:20px;font-weight:bold;}
.zkform .zk-done-text{margin:0 0 10px;}
.zkform .zk-done-sum{display:grid;grid-template-columns:auto 1fr;gap:4px 14px;margin:0;padding:10px 14px;background:#fff;border:1px solid #c8e6c9;border-radius:6px;font-size:14px;color:#333;}
.zkform .zk-done-sum dt{font-weight:bold;color:#555;white-space:nowrap;}
.zkform .zk-done-sum dd{margin:0;word-break:break-all;}
`
